import React from 'react';
import {
  BreadcrumbBar,
  BreadcrumbContainer,
  BreadcrumbCurrent,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from './styles/Breadcrumbs.styles';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs = ({ items }: BreadcrumbsProps) => (
  <BreadcrumbBar aria-label="Breadcrumb">
    <BreadcrumbContainer>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={item.label}>
            {isLast || !item.to ? (
              <BreadcrumbCurrent>{item.label}</BreadcrumbCurrent>
            ) : (
              <BreadcrumbLink to={item.to}>{item.label}</BreadcrumbLink>
            )}
            {!isLast && <BreadcrumbSeparator aria-hidden="true">&rsaquo;</BreadcrumbSeparator>}
          </React.Fragment>
        );
      })}
    </BreadcrumbContainer>
  </BreadcrumbBar>
);

export default Breadcrumbs;
